<template>
    <span class="search-trigger" @click.prevent="toggle()"><i class="fa fa-search fa-fw"></i></span>
</template>
<script>
    export default {
        methods: {
            toggle() {
                window.EventHandler.fire('toggle-search');
            }
        }
    }
</script>